"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createNextOpenItems: function() {
        return createNextOpenItems;
    },
    useControllableOpenItems: function() {
        return useControllableOpenItems;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _reactutilities = require("@fluentui/react-utilities");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _ImmutableSet = require("../utils/ImmutableSet");
const _createOpenItems = require("../utils/createOpenItems");
function useControllableOpenItems(props) {
    return (0, _reactutilities.useControllableState)({
        state: _react.useMemo(()=>props.openItems && (0, _createOpenItems.createOpenItems)(props.openItems), [
            props.openItems
        ]),
        defaultState: props.defaultOpenItems && (()=>(0, _createOpenItems.createOpenItems)(props.defaultOpenItems)),
        initialState: _ImmutableSet.ImmutableSet.empty
    });
}
function createNextOpenItems(data, previousOpenItems) {
    if (data.value === null) {
        return previousOpenItems;
    }
    const previousOpenItemsHasId = previousOpenItems.has(data.value);
    if (data.open ? previousOpenItemsHasId : !previousOpenItemsHasId) {
        return previousOpenItems;
    }
    const nextOpenItems = _ImmutableSet.ImmutableSet.create(previousOpenItems);
    return data.open ? nextOpenItems.add(data.value) : nextOpenItems.delete(data.value);
}
